export const header = [
    {name: 'Home', route: '/'},
    {name: 'About iLease', route: '/about-ilease'},
    {name: 'My Car', route: '/my-car'},
    {name: "FAQ's", route: '/faqs'},
    {name: "Let's Connect", route: "/let's-connect"},
]